import { mapGetters } from 'vuex';
import marketTrendsDropdown from '@/market-trends/components/markettrendsdropdown/markettrends-dropdown.vue';
import marketTrendsTabHeader from '@/market-trends/components/markettrendstabheader/markettrends-tabheader.vue';
export default {
    name: 'marketTrendsTabs',
    components: {
      marketTrendsDropdown,
      marketTrendsTabHeader
    },
    inject: ['$eventBus'],
    props: {
      trendMetricsData: {
        type: Array,
        default: () => []
      },
      widgetOptions: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        selectedTabForDropDown: {name: '', id: ''},
        selectedTabIndex: 0, // the index of the selected tab,
        tabs: [], // all of the tabs
        tabMetricsHeader: [],
        marketTrendTabs:[
          { id: 'medianlistprice', name: 'Price', metric_title: 'Median List Price' },
          { id: 'medianpricepersqft', name: '$/Sqft', metric_title: 'Median $/Sqft' },
          { id: 'inventory', name: 'Inventory', metric_title: 'Inventory' },
          { id: 'mediansize', name: 'Home Size', metric_title: 'Median Home Size Sqft' },
          { id: 'mediandom', name: 'Days on Market', metric_title: 'Median Days on Market' },
        ],
        selectedTabId: 'medianlistprice'
      };
    },
    computed: {
      ...mapGetters('glb', ['glb']),
      getTrendsData(){
       return this.tabMetricsHeader;
      }
    },
    mounted () {
      let view = (this.widgetOptions && this.widgetOptions.view) || 0;
     if(this.widgetOptions && this.widgetOptions.type === 'vwidgethearstmarketinsight'){
         this.tabs = this.$slots.default() && this.$slots.default().length ? this.$slots.default()[0].children.filter(child => child.type.name === 'marketTrendsTab') : [];
         this.selectTab(view);
      } else{
        this.tabs =  this.$refs.items || [];
      }

      if(this.trendMetricsData && this.trendMetricsData.length){
        for(var i = 0; i < this.trendMetricsData.length; i++){
          this.tabMetricsHeader.push({name: this.trendMetricsData[i].metric_title, id: i});
        }
        this.selectedTabForDropDown = this.tabMetricsHeader[view];
      }
    },
    methods: {
      selectTab (value) {
        this.selectedTabIndex = value.hasOwnProperty('id') ? value.id : value;
        if(this.tabMetricsHeader){
          this.selectedTabForDropDown = this.tabMetricsHeader[this.selectedTabIndex];
        }
        if(this.tabs && this.tabs.length > 0){
          this.$eventBus.$emit('eventbus-selectTab', this.selectedTabIndex);
        }
      },
      selectTabMarket(tab){
        this.selectedTabId = tab.id;
        this.$emit('updateMetric', tab);
      }
    }
  };
